
import * as __star__ from '@clayui/multi-step-nav';

const {
default: __default__,
ClayMultiStepNavWithBasicItems,
__esModule
} = __star__;

export {
ClayMultiStepNavWithBasicItems,
__esModule
};
export default __default__;
